import Show from '../views/projects/show'
import List from '../views/projects/list'

export default [
    {
        path: '/admin/projects',
        name: 'projects',
        component: List,
    },
    {
        path: '/admin/project/:id',
        name: 'project-show',
        component: Show,
    }
]
